/**
 * Logos Block JavaScript - smooth infinite horizontal scroll
 */

(function() {
    'use strict';

    const PX_PER_SECOND = 80;

    function initLogos() {
        document.querySelectorAll('.logos').forEach(block => {
            const track = block.querySelector('.logos__track');
            const sets = block.querySelectorAll('.logos__set');
            if (!track || sets.length < 2) return;

            const setWidth = sets[0].offsetWidth;
            let position = 0;
            let lastTime = null;

            function loop(now) {
                if (lastTime != null) {
                    const delta = (now - lastTime) / 1000;
                    if (setWidth > 0) {
                        position += PX_PER_SECOND * delta;
                        if (position >= setWidth) position -= setWidth;
                    }
                }
                lastTime = now;
                track.style.transform = 'translate3d(-' + position + 'px, 0, 0)';
                requestAnimationFrame(loop);
            }

            requestAnimationFrame(loop);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLogos);
    } else {
        initLogos();
    }
})();